import React, { Fragment, useState, useCallback, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
// import axios from 'axios';
import EditTagDetails from './EditTagDetails';
import { Link } from 'react-router-dom';
import AddTagDetails from './AddTagDetails';
import { Btn, Breadcrumbs, H4 } from '../../../AbstractElements';
import { tableColumns } from '../../../Data/DataTable/Tagsdetails/tagsdetails';
import { ServerPath } from '../../../Constant';
import Swal from 'sweetalert2';
import { Button } from 'react-bootstrap';
import { _axios } from '../../../utils/axios'; 

const DataTablesContain = () => {
  const [tagDetails, setTagDetails] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await _axios.get(`${ServerPath}/waypointDetails/getAllGpxRoutes`);
        const actualData = response?.data?.data;
        console.log(actualData)
        const tagData = actualData.map(tag => ({
          ...tag,
          Tag_Details_Name: <div className="align-self-center"><div>{tag?.Tag_Details_Name}</div></div>,
          Status: <span
            className={`badge rounded-pill ${tag?.Status === 1 ? 'badge-success' : 'badge-danger'}`}
            data-bs-toggle="modal"
            data-bs-target=".bd-example-modal-sm"
          >
            {tag?.Status === 1 ? 'Active' : 'Inactive'}
          </span>,
          action: (
            <div className="action d-flex justify-content-center">
              <div className="edit">
                <EditTagDetails tagDetails={tag} onUpdate={() => fetchData()} />
              </div>
              <div className="delete">
                <Button className="btn-square btn btn-danger mx-2" onClick={(e) => handleDeleteID(tag?.id, e)} >
                  <i className="icon-trash"></i>
                </Button>
              </div>
            </div>
          ),
        }));
        setTagDetails(tagData);
        console.log("tag = ", tagData)
      } catch (error) {
        console.error('Error fetching tag details:', error);
      }
    };
    fetchData();
  }, []);

  const handleDeleteID = async (id, event) => {
    event.preventDefault();
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!',
      customClass: {
        container: 'swal2-container'
      }
    });

    if (result.isConfirmed) {
      try {
        await _axios.delete(`${ServerPath}/waypointDetails/${id}`);
        setTagDetails(prevTags => prevTags.filter(tag => tag.id !== id));
        Swal.fire(
          'Deleted!',
          'Your tag details has been deleted.',
          'success'
        );
      } catch (error) {
        console.error('Error deleting tag details:', error);
        Swal.fire(
          'Error!',
          'There was an error deleting the tag details.',
          'error'
        );
      }
    }
  };

  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleDelete, setToggleDelete] = useState(false);

  const handleRowSelected = useCallback(state => {
    setSelectedRows(state.selectedRows);
  }, []);

  const handleDelete = () => {
    if (window.confirm(`Are you sure you want to delete:\r ${selectedRows.map(r => r.title)}?`)) {
      setToggleDelete(!toggleDelete);
      setTagDetails(tagDetails.filter((item) => selectedRows.filter((elem) => elem.id === item.id).length > 0 ? false : true));
      setSelectedRows([]);
    }
  };

  return (
    <Fragment>
      <div className='row'>
        <div className='col-12 col-md-6 col-lg-6'>
          <Breadcrumbs mainTitle="Waypoint Details" parent="Tables" title="Waypoint Details" />
        </div>
        <div className='col-12 col-md-6 col-lg-6'>
          <AddTagDetails />
        </div>
      </div>
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody className='pt-0'>
                {(selectedRows.length !== 0) &&
                  <div className={`d-flex align-items-center justify-content-between bg-light-info p-2`}>
                    <H4 attrH4={{ className: 'text-muted m-0' }}>Delete Selected Data?</H4>
                    <Btn attrBtn={{ color: 'danger', onClick: () => handleDelete() }}>Delete</Btn>
                  </div>
                }
                <DataTable
                  className='data-tables theme-scrollbar pt-4'
                  data={tagDetails}
                  columns={tableColumns}
                  striped={true}
                  center={true}
                  pagination
                  selectableRows
                  onSelectedRowsChange={handleRowSelected}
                  clearSelectedRows={toggleDelete}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default DataTablesContain;